<template lang="html">
  <div class="">
    <si-container>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-layout align-center>
              <v-avatar
                v-if="xeroStatus.connected && !xeroStatusLoading"
                class="profile"
                color=""
                size="64"
                tile
              >
                <v-img src="https://cdn.iconscout.com/icon/free/png-512/xero-283320.png" />
              </v-avatar>
              <v-flex>
                Xero
                <div class="caption">
                  {{ xeroStatus.tenantName }}
                </div>
              </v-flex>

              <v-flex
                v-if="!xeroStatus.connected && !xeroStatusLoading"
                shrink
              >
                <v-btn 
                  color="info" 
                  depressed 
                  :loading="xeroAuthLoading" 
                  @click="connectXero"
                >
                  Connect Xero
                </v-btn>
              </v-flex>
              <v-flex
                v-if="xeroStatus.connected && !xeroStatusLoading"
                shrink
              >
                <SiDeleteButton
                  title="Disconnect Xero"
                  message="Are you absolutely sure? Very bad things will happen"
                  delete-button-text="Disconnect"
                  @delete="disconnectXero"
                >
                  <template #activator="{ attrs, on }">
                    <v-btn 
                      v-bind="attrs"
                      color="error"
                      depressed 
                      :loading="xeroAuthLoading" 
                      v-on="on" 
                    >
                      Disconnect
                    </v-btn>
                  </template>
                </SiDeleteButton>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>Enabled Clients</v-card-title>
          <v-card-title>
            <v-text-field
              v-model="email"
              label="Add email address or domain"
              outlined
              append-icon="add"
              type="email"
              name="email"
              hide-details
              @click:append="addEmail"
              @keydown.enter="addEmail"
            />
          </v-card-title>
          <v-list>
            <div
              v-for="(email, i) in emailList"
              :key="email.id"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ email.email }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    icon
                    small
                    class="ma-0"
                    @click="() => removeEmail(email.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="i < emailList.length -1" />
            </div>
          </v-list>
        </v-card>
      </v-flex>
    </si-container>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import { rtdb } from "@/plugins/firebase";
import helpers from "@/mixins/helpers";
import binder from "@/mixins/binder";
import axios from "@/app-console/plugins/axios";

export default {
  mixins: [helpers, binder],
  data() {
    return {
      email: "",
      emails: {},
      xeroStatus: { connected: null },
      xeroStatusLoading: true,
      xeroAuthWindow: null,
      xeroAuthLoading: false,
    };
  },
  computed: {
    // ...mapGetters(["_loader"]),
    emailList() {
      return Object.keys(this.emails || {}).map((id) => {
        return { id, email: this.emails[id] };
      });
    },
  },
  watch: {
    xeroStatus(v) {
      if (v.connected && this.xeroAuthLoading) this.xeroAuthLoading = false;
      if (v.connected && this.xeroAuthWindow) {
        this.xeroAuthWindow.close();
      }
    },
  },
  beforeMount() {
    this.$bindDb("xeroStatus", "xero/status", { loader: "xeroStatusLoading" });
    this.$bindRtdb("emails", "invoicing/enabledFor", { loader: true });

    this.$store.commit("set_appBarTitle", {
      title: "Invoicing",
      icon: "receipt",
    });
  },
  mounted() {},
  methods: {
    addEmail() {
      let { email } = this;
      let id = btoa(email || "");

      if (!email) return null;

      rtdb.ref(`invoicing/enabledFor/${id}`).set(email);
      this.email = "";
    },
    removeEmail(id) {
      rtdb.ref(`invoicing/enabledFor/${id}`).set(null);
    },
    async connectXero() {
      const { data: authUrl } = await axios.get(
        `${process.env.VUE_APP_API_URL}/xero/auth`
      );
      if (authUrl) {
        this.xeroAuthLoading = true;
        this.xeroAuthWindow = window.open(authUrl, "_blank");
      }
    },
    async disconnectXero() {
      await axios.post(`${process.env.VUE_APP_API_URL}/xero/auth/disconnect`);
    },
  },
};
</script>

<style lang="css" scoped>
</style>
